<template>
<div class="row" >

<div v-for="contenido in contenidos" :key="contenido.index" class="card caja-tarjeta col-12 col-md-12" :class="columnasContenido(contenido.TamanoDeLaColumna)" style="width: 18rem;">
<router-link v-if="contenido.AbrirEnVisor==false && contenido.RutaDeArchivo != null && contenido.RutaDeArchivo.includes('Micrositio')" :to="contenido.RutaDeArchivo" ><img class="imagen" :src="contenido.RutaDeImagen" alt="Tarjeta de Imagen"></router-link>
 <a v-else-if="contenido.AbrirEnVisor==false && contenido.RutaDeArchivo != null && contenido.RutaDeArchivo.includes('http') && !contenido.RutaArchivoCarpeta.includes('themisfstest\\Files')" target="_blank" :href="contenido.RutaDeArchivo"><img class="imagen"  :src="contenido.RutaDeImagen" alt="Tarjeta de Imagen"></a>
 <a v-else-if="contenido.AbrirEnVisor==false && contenido.RutaDeArchivo != null" v-on:click="AbrirArchivo(contenido.RutaArchivoCarpeta)">  <img class="imagen"  :src="contenido.RutaDeImagen" alt="Tarjeta de Imagen"></a>
 <a v-else-if="contenido.AbrirEnVisor==true && contenido.RutaDeArchivo != null" v-on:click="AbreElVisor(contenido.RutaArchivoCarpeta)">  <img class="imagen"  :src="contenido.RutaDeImagen" alt="Tarjeta de Imagen"></a>
 <a v-else-if="contenido.RutaArchivoCarpeta==null"><img class="imagen"  :src="contenido.RutaDeImagen" alt="Tarjeta de Imagen"></a>

  <div class="card-body caja-texto" >
     
     <h4 class="title">{{contenido.TextoDelVinculo}}</h4>
    <p class="descripcion">{{contenido.TextoDelContenido}}</p> 
   
    <p class="card-text"><small class="text-muted">{{restaFechas(contenido.FechaDePublicacion)}}</small></p>
  </div>


</div>


</div>


</template>

<script>
import comun from "@/../static/js/comun";
export default {
    props:{
        contenidos:Array
    },
    methods:{
restaFechas (fecha) { 
     let fechaPublicacion = fecha.split('-');               
     var nacimiento = new Date(fechaPublicacion[0],fechaPublicacion[1]-1,fechaPublicacion[2].substr(-20,2))
    var hoy = new Date()
    var tiempoPasado= hoy - nacimiento
    var segs = 1000;
    var mins = segs * 60;
    var hours = mins * 60;
    var days = hours * 24;
    var months = days * 30.416666666666668;
    var years = months * 12;

//calculo 
 var anios = Math.floor(tiempoPasado / years);
tiempoPasado = tiempoPasado - (anios * years);
var meses = Math.floor(tiempoPasado / months)
tiempoPasado = tiempoPasado - (meses * months);
var dias = Math.floor(tiempoPasado / days)
tiempoPasado = tiempoPasado - (dias * days);
var horas = Math.floor(tiempoPasado / hours)
tiempoPasado = tiempoPasado - (horas * hours);
var minutos = Math.floor(tiempoPasado / mins)
tiempoPasado = tiempoPasado - (minutos * mins);
var segundos = Math.floor(tiempoPasado / segs)    

 return this.obtenerMensaje(dias,anios,meses);
},
obtenerMensaje(dias,anios,meses){
    var msg  = '';
    let mensajeDias='dias';
    let mensajeMeses='meses';
    let mensajeAnios = 'años';
    if(dias == 0 && anios == 0 && meses == 0)      msg = "Publicado hace un momento";
    else if( dias > 0 && anios == 0 && meses == 0) {
    if(dias==1) mensajeDias = 'dia'; 
    msg = `Publicado hace ${dias} ${mensajeDias}`;
    }
    else if( dias == 0 && anios == 0 && meses > 0){
    if(meses==1) mensajeMeses = 'mes'; 
    msg = `Publicado hace ${meses} ${mensajeMeses}`;
    } 
else if( dias == 0 && anios > 0 && meses == 0) {
    if(anios==1) mensajeAnios = 'año'; 
    msg = `Publicado hace ${anios} ${mensajeAnios}`;
}
else if( dias > 0 && anios == 0 && meses > 0) {
    if(dias==1) mensajeDias = 'dia';
    if(meses==1) mensajeMeses = 'mes';  
     msg = `Publicado hace ${meses} ${mensajeMeses} y ${dias} ${mensajeDias}`;
}
else if( dias > 0 && anios > 0 && meses == 0) {
    if(dias==1) mensajeDias = 'dia';
    if(anios==1) mensajeAnios = 'año'; 
    msg = `Publicado hace ${anios} ${mensajeAnios} y ${dias} ${mensajeDias}`;
} 
else if( dias == 0 && anios > 0 && meses > 0) {
    if(anios==1) mensajeAnios = 'año'; 
    if(meses==1) mensajeMeses = 'mes';  
    msg = `Publicado hace ${anios} ${mensajeAnios} y ${meses} ${mensajeMeses}`;
} 
else if( dias > 0 && anios > 0 && meses > 0) {
    if(anios==1) mensajeAnios = 'año'; 
    if(meses==1) mensajeMeses = 'mes'; 
    if(dias==1) mensajeDias = 'dia';  
    msg = `Publicado hace ${anios} ${mensajeAnios}, ${meses} ${mensajeMeses} y ${dias} ${mensajeDias}`;
} 
return msg 
},

columnasContenido(columnas){
     var respuesta = 'col-lg-'+columnas;
     return respuesta;

 },
  AbreElVisor: function(vinculo) {
       this.$store.dispatch('A_PaginaOficial_EstableceLaRutaParaElVisor', vinculo);
      },
 AbrirArchivo: function(vinculo,forma) {
          comun.DescargarDocumentoPDF(vinculo)
           // window.open(vinculo,forma);
        },
  

   

    },
    
  
}
</script>

<style scoped>
.caja-texto{
    background-color:rgba(233, 233, 233, 0.384);
    width:80%;
    display:block;
    margin:auto;
}
.imagen{
display:block;
margin:auto;
width:80%;
height:30em;
margin:auto;
}
.card{
    margin-bottom: 2rem;
    padding-top: 2vh;
    border: none;
}
.title{
    text-align: center;
    font-size: 20px;
    color: #000000;
    font-weight: 100;
    font-family: 'AntenaBeta'
}
.descripcion{
    text-align: center;
    font-size: 1.2em;
    color: #000000;
    font-weight: 100;
    font-family: 'Myriad'
}

.caja-tarjeta{
    background-color: #ffffff;

}

.caja-tarjeta:hover {
    background-color: rgba(163, 157, 146, 0.9);
     /*  background-color: rgba(190,154,94,.9); */
       transform: translateY(-15px);
}

 

</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/ImagenConVinculo.vue